import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout";
import { SplashScreen } from "../../../_metronic/_partials/controls";
import { DashboardPage } from "../DashboardPage";
import Dashboard from "./Dashboard";
import HRDashboard from "./HRDashboard";
import { shallowEqual, useSelector } from "react-redux";
import DashboardSwitcher from "./DashboardSwitcher";
import DemoDashboard from "./DemoDashboard";
// import Dashboard from "./Dashboard";

export default function AllDashboardPages() {
  // Redux state selectors
  const { auth } = useSelector(
    ({ auth }) => ({
      auth: auth.coreModuleInfo,
    }),
    shallowEqual
  );
  return (
    <Suspense fallback={<SplashScreen />}>
      <Switch>
        {/* <Redirect exact from="/" to="/dashboard" /> */}
        {/* <ContentRoute
          path="/dashboard"
          component={
            auth?.role_slugs?.includes("hr_admin") ? HRDashboard : Dashboard
          }
        /> */}
        {/* <ContentRoute
          path="/dashboard"
          exact
          component={
            auth?.role_slugs?.includes("hr_admin") ? HRDashboard : DashboardPage
          }
        /> */}
        <ContentRoute path="/dashboard" component={DemoDashboard} />
        {/* <ContentRoute path="/dashboard" component={DashboardSwitcher} /> */}
        {/* <ContentRoute path="/dashboard" component={DashboardPage} /> */}
      </Switch>
    </Suspense>
  );
}
